import Vue from 'vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js/dist/Chart.min'

Vue.use(Chartkick.use(Chart))
